module.exports = __webpack_public_path__ + "static/media/img2.a7acef41.png";